import { motion } from "framer-motion";
import { MapPin, ChevronRight } from "lucide-react";
import { fadeInUp, staggerContainer } from "@/lib/constants";

export const SobreMiSection = () => {
  return (
    <section id="sobre-mi" className="relative section-padding bg-slate-900/50" data-testid="about-section">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={staggerContainer}
          className="grid lg:grid-cols-2 gap-12 items-center"
        >
          <motion.div variants={fadeInUp} className="relative order-2 lg:order-1">
            <div className="relative max-w-md mx-auto lg:mx-0">
              <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="https://customer-assets.emergentagent.com/job_0fa390b6-dfb3-4754-889e-9bcf0f7baadd/artifacts/5t1lllc5__DSC7951-Editar%20%281%29%20%281%29.jpg"
                  alt="Antonio Oliver - Analista de Datos en Murcia"
                  className="w-full h-auto object-cover"
                  data-testid="about-photo"
                />
              </div>
              <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 z-20">
                <div className="glass px-4 py-2 rounded-full flex items-center gap-2">
                  <MapPin className="w-4 h-4 text-indigo-400" />
                  <span className="text-sm font-medium text-white">Murcia, España</span>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div variants={fadeInUp} className="order-1 lg:order-2">
            <span className="text-indigo-400 font-medium text-sm uppercase tracking-wider font-mono">Quién hay detrás</span>
            <h2 className="text-3xl sm:text-4xl font-bold mb-2 mt-4 line-decoration">
              Antonio Oliver
            </h2>
            <p className="text-cyan-400 font-medium mb-6">Analista de datos · Especialista BI · SQL · Power BI · Python</p>

            <div className="space-y-4 text-slate-400 text-sm md:text-base">
              <p>
                Perfil híbrido entre <span className="text-white font-medium">negocio y datos</span>.
                Mi trabajo es coger información dispersa (ERP, CRM, hojas de cálculo, APIs, bases de
                datos) y convertirla en algo que dirección pueda usar para decidir: dashboards, KPIs
                y modelos predictivos sobre datos reales.
              </p>
              <p>
                Formación: ingeniería telemática + máster en Data Science + máster en Inteligencia
                Artificial. Antes de trabajar como freelance pasé varios años como analista de datos
                en empresa, así que conozco bien lo que es lidiar con un ERP mal mantenido, un Excel
                de 80 MB y un departamento que necesita el informe para ayer.
              </p>
              <p>
                <span className="text-white font-medium">No soy agencia.</span> Trabajo directamente:
                escribo las consultas SQL, configuro el modelo, monto los dashboards en Power BI y
                automatizo lo que tenga que automatizarse con Python. Sin intermediarios, sin equipo
                de cuenta, sin reuniones que no aportan.
              </p>
              <p>
                Sectores donde más resultados saco: <span className="text-white font-medium">industria,
                distribución, logística, agroalimentación</span> y pymes con ERP. En general, cualquier
                empresa con muchos datos y poco análisis real.
              </p>
            </div>

            <div className="glass-card rounded-xl p-6 mt-8">
              <p className="text-slate-300 mb-4 font-medium">
                Las preguntas que mejor respondo con tus datos:
              </p>
              <ul className="space-y-2 text-slate-400 text-sm">
                <li className="flex items-center gap-2">
                  <ChevronRight className="w-4 h-4 text-indigo-400" />
                  ¿Qué productos y clientes generan margen real, una vez descontados todos los costes?
                </li>
                <li className="flex items-center gap-2">
                  <ChevronRight className="w-4 h-4 text-indigo-400" />
                  ¿Qué referencias tengo paradas en stock y cuánto capital están bloqueando?
                </li>
                <li className="flex items-center gap-2">
                  <ChevronRight className="w-4 h-4 text-indigo-400" />
                  ¿Cuánto se va a vender el mes que viene por SKU, zona y canal?
                </li>
                <li className="flex items-center gap-2">
                  <ChevronRight className="w-4 h-4 text-indigo-400" />
                  ¿Qué reportes que hoy hacemos a mano pueden ejecutarse solos?
                </li>
              </ul>
              <div className="mt-6 pt-4 border-t border-slate-700/50">
                <p className="text-indigo-400 font-semibold text-sm uppercase tracking-wider font-mono">
                  Stack: SQL · Power BI · DAX · Python · Power Query · APIs · ETL
                </p>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};
